module["exports"] = [
  "#{street_prefix} #{Name.first_name}",
  "#{street_prefix} #{Name.last_name}"
];


//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/id_ID/address/street_name.js
// module id = 1208
// module chunks = 1